import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommandBase } from '../../model/command';

export interface ICommandHandler {
  canExecute(command: CommandBase): boolean;
  execute(command: CommandBase): Observable<boolean | void>;
}

export interface IDestroy {
  destroy(): void;
}

@Injectable()
export class CommandHandlerResolver implements IDestroy {
  constructor() {
    this._handlers = { '': null };
  }

  private readonly _handlers: { [key: string]: ICommandHandler };

  protected addHandler(commandId: string, handler: ICommandHandler): void {
    if (this._handlers[commandId]) throw new Error(`The command handler for ${commandId} has been already registered.`);
    this._handlers[commandId] = handler;
  }

  destroy(): void {}

  canResolve(command: CommandBase): boolean {
    if (!command) throw new Error('An invalid command.');

    return this._handlers[command.id] != null;
  }

  resolve(command: CommandBase): ICommandHandler {
    if (!command) throw new Error('An invalid command.');

    let handler = this._handlers[command.id];
    if (!handler) throw new Error(`Can't resolve handler for ${command.id}.`);

    return handler;
  }
}
